import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const authHeaders = () => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");

  return token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
};

export const getUserAdminPermissions = async (userId) => {
  if (!userId) return [];

  try {
    const { data } = await axios.get(
      `${apiUrl}/api/users/${userId}/admin-permissions`,
      {
        headers: authHeaders(),
      }
    );

    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error("Erreur getUserAdminPermissions :", error);
    return [];
  }
};